import { render, staticRenderFns } from "./TagPill.vue?vue&type=template&id=d0912462&scoped=true&"
import script from "./TagPill.vue?vue&type=script&lang=js&"
export * from "./TagPill.vue?vue&type=script&lang=js&"
import style0 from "./TagPill.vue?vue&type=style&index=0&id=d0912462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0912462",
  null
  
)

export default component.exports